import {
  ChangeDetectionStrategy,
  Component,
  Input,
} from '@angular/core';

import { SvgDocumentOneListModule } from '../../../../shared/svg/svg-document-one-list/svg-document-one-list.module';
import { Wizard, WizardLoadingType } from '../../../../shared/wizard-v2/wizard-core/wizard/wizard';
import { WizardComponent } from '../../../../shared/wizard-v2/wizard-core/wizard/wizard.component';
import { WizardThreeStepsContainerModule } from '../../../../shared/wizard-v2/wizard-types/wizard-three-steps/components/wizard-three-steps-container/wizard-three-steps-container.module';
import { AccordeonComponent } from '../../../../ui/controls/accordeon/accordeon.component';
import { ReferencesWizardBaseComponent } from '../common/reference-wizard.base';
import { ReferenceFormStep } from '../common/steps/references-form-step';
import { ReferenceResultStep } from '../common/steps/references-result-step';
import { Reference } from '../references.entities';

@Component({
	selector: 'app-references-without-group-wizard',
	templateUrl: './references-without-group-wizard.component.html',
	styleUrls: ['./references-without-group-wizard.component.less'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [
		AccordeonComponent,
		SvgDocumentOneListModule,
		WizardThreeStepsContainerModule,
	],
})
export class ReferencesWithoutGroupWizardComponent extends ReferencesWizardBaseComponent implements WizardComponent {

	@Input()
	public reference: Reference

	public onToggle(isOpen: boolean): void {
		if (isOpen && !this.wizard) {
			this.wizard = new Wizard(this.reference.referenceName, {
				wizardLoadingType: WizardLoadingType.onStep,
				progressBarHidden: true,
				goBackInvisible: true,
			});

			const step1: ReferenceFormStep = new ReferenceFormStep(this, this.wizard);
			const step2: ReferenceResultStep = new ReferenceResultStep(this, this.wizard);

			this.wizard.addStep(step1);
			this.wizard.addStep(step2);

			this.wizard.next(this.reference);

		}
	}

}
